import { motion } from 'framer-motion'
import { Star, Quote } from 'lucide-react'

const TestimonialsSection = () => {
  const testimonials = [
    {
      name: 'Maria Silva',
      role: 'Proprietária',
      company: 'Academia Aquática Vida',
      content: 'A solução revolucionou nossa gestão. A automatização dos pagamentos reduziu nossa inadimplência em 60% e os alunos adoram acompanhar seu progresso pelo app.',
      rating: 5,
      avatar: '/logomarca_cliente_piloto_agua_vida.jpeg'
    },
    {
      name: 'João Santos',
      role: 'Diretor',
      company: 'Natação Express',
      content: 'Implementamos o sistema em apenas uma semana. Os relatórios financeiros são excelentes e a comunicação com os alunos melhorou muito.',
      rating: 5,
      avatar: null
    },
    {
      name: 'Ana Costa',
      role: 'Coordenadora',
      company: 'Swim Academy',
      content: 'O app do professor facilitou muito nosso trabalho. Conseguimos fazer avaliações mais detalhadas e manter contato direto com os alunos.',
      rating: 5,
      avatar: null
    }
  ]

  return (
    <section className="py-20 bg-white">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h2 className="text-3xl lg:text-4xl font-bold text-dark-900 mb-4">
            O que nossos clientes dizem
          </h2>
                      <p className="text-xl text-gray-600 max-w-3xl mx-auto">
              Escolas de natação de todo o Brasil já estão transformando 
              seus negócios com nossa solução.
            </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
          {testimonials.map((testimonial, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
              className="group"
            >
              <div className="card h-full hover:shadow-xl transition-all duration-300 group-hover:-translate-y-1">
                {/* Quote Icon */}
                <div className="mb-6">
                  <Quote className="h-8 w-8 text-primary-600" />
                </div>

                {/* Rating */}
                <div className="flex items-center mb-4">
                  {[...Array(testimonial.rating)].map((_, i) => (
                    <Star key={i} className="h-5 w-5 text-yellow-400 fill-current" />
                  ))}
                </div>

                {/* Content */}
                <p className="text-gray-700 mb-6 leading-relaxed">
                  "{testimonial.content}"
                </p>

                {/* Author */}
                <div className="flex items-center space-x-4">
                  {testimonial.avatar ? (
                    <img 
                      src={testimonial.avatar} 
                      alt={testimonial.name}
                      className="w-12 h-12 rounded-full object-cover"
                    />
                  ) : (
                    <div className="w-12 h-12 bg-primary-100 rounded-full flex items-center justify-center">
                      <span className="text-primary-600 font-semibold">
                        {testimonial.name.charAt(0)}
                      </span>
                    </div>
                  )}
                  
                  <div>
                    <div className="font-semibold text-dark-900">
                      {testimonial.name}
                    </div>
                    <div className="text-sm text-gray-600">
                      {testimonial.role} • {testimonial.company}
                    </div>
                  </div>
                </div>
              </div>
            </motion.div>
          ))}
        </div>

        {/* Bottom CTA */}
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center mt-16"
        >
          <p className="text-gray-600 mb-6">
            Quer fazer parte dessa transformação?
          </p>
          <a href="/contato" className="btn-primary">
            Solicitar Demo Gratuito
          </a>
        </motion.div>
      </div>
    </section>
  )
}

export default TestimonialsSection
